import { Link } from '@tanstack/react-router';
import { useUi } from '@/store/uiStore';

export function Sidebar() {
  const open = useUi((s) => s.mobileMenuOpen);
  const setOpen = useUi((s) => s.setMobileMenuOpen);
  const close = () => setOpen(false);

  return (
    <>
      {open && <div className="mobile-menu-scrim" onClick={close} aria-hidden="true" />}
      <aside
        className="sidebar"
        aria-label="Primary"
        data-open={open ? 'true' : 'false'}
      >
        <h2>JND Bible</h2>
        <p
          className="faint"
          style={{
            fontFamily: 'var(--font-serif)',
            fontStyle: 'italic',
            fontSize: '.85rem',
            margin: '0 0 1rem',
          }}
        >
          Be still, and know.
        </p>
        <nav aria-label="Primary">
          <Link to="/" activeOptions={{ exact: true }} onClick={close}>
            <span aria-hidden>📖</span> JND Bible
          </Link>
          <Link to="/meetings" onClick={close}>
            <span aria-hidden>⛪</span> Meetings
          </Link>
          <Link to="/favourites" onClick={close}>
            <span aria-hidden>★</span> My Favourites
          </Link>
          <Link to="/notes" onClick={close}>
            <span aria-hidden>✎</span> My Notes &amp; Jottings
          </Link>
          <Link to="/sessions" onClick={close}>
            <span aria-hidden>≡</span> My Study Sessions
          </Link>
          <Link to="/plans" onClick={close}>
            <span aria-hidden>☷</span> My Reading Plans
          </Link>
        </nav>
        <div className="sidebar-footer">
          <nav aria-label="Settings">
            <Link to="/settings" onClick={close}>
              <span aria-hidden>⚙</span> Settings
            </Link>
            <Link to="/about" onClick={close}>
              <span aria-hidden>ⓘ</span> About
            </Link>
          </nav>
        </div>
      </aside>
    </>
  );
}
